import LazyImage from "@Components/Image";
import WeChatIcon from "@Icons/WeChatIcon";
import { BASE_OSS_URL } from "constants/configConstants";
import styles from "./ChinaAppBanner.module.scss";

const QR_IMAGE_SRC = `${BASE_OSS_URL}/dwebcnqrexpanded_360.png`;

const ChinaAppBanner = () => (
  <div className={styles.container}>
    <LazyImage
      src={QR_IMAGE_SRC}
      alt="WeChat Mini Program QR Code"
      className={styles.qrImage}
      width={220}
      height={220}
    />
    <hr className={styles.divider} />
    <div className={styles.footer}>
      <WeChatIcon />
      <span className={styles.footerText}>扫描以添加小程序</span>
    </div>
  </div>
);

export default ChinaAppBanner;
